/* eslint-disable react/prop-types */
import * as userSelectors from '@/user/user-selectors';
import { getNewPlatformIcon } from '@/widgets/components/online-platform-icon';
import archiveIcon from '@iconify/icons-feather/archive';
import { InlineIcon } from '@iconify/react';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  ListingSectionTitle,
  ListingSectionTitleWrapper,
  LiveNotLiveButton,
  NavButtonsWrapper,
  StyledIconButton,
  VerifiedListingIcon,
} from './listing-info-title-styles';
import { CyborgButton } from './title-mod/cyborg-button';
import { ListingVerificationButton } from './title-mod/listing-verification-button';

export function ListingInfoTitle(props) {
  const { listing } = props;
  const { pdfs = [] } = listing;

  const isAdmin = useSelector(userSelectors.isAdmin);
  const currentCity = useSelector(userSelectors.currentCity);

  // Some sort of legacy logic/type coercion
  const listingLive = +listing.live;
  const pdfsAvailable = pdfs.some((pdf) => pdf?.url);

  const PlatformIcon = useMemo(
    () => getNewPlatformIcon(listing.platform),
    [listing.platform]
  );

  return (
    <ListingSectionTitleWrapper>
      <ListingSectionTitle>
        {props.title}
        <VerifiedListingIcon
          isProperty={false}
          verifiedStatus={listing.verifiedStatus}
        />
      </ListingSectionTitle>
      <NavButtonsWrapper>
        <CyborgButton
          isAdmin={isAdmin}
          listingDeckardID={listing.deckardid}
          currentCity={currentCity}
        />

        <ListingVerificationButton
          listing={listing}
          setActiveDeckardId={props.setActiveDeckardId}
          enableListingPopover={props.enableListingPopover}
        />

        <StyledIconButton
          aria-label="View historic listing details"
          disabled={!pdfsAvailable}
          size="sm"
          icon={
            <InlineIcon aria-hidden icon={archiveIcon} className="rs-icon" />
          }
          placement="left"
          onClick={() => props.onPdfClick(listing)}
        >
          History
        </StyledIconButton>

        <LiveNotLiveButton
          aria-label={
            listingLive
              ? 'Open live listing page'
              : 'Open historic listing page'
          }
          islivelisting={listingLive}
          size="sm"
          icon={
            <PlatformIcon
              aria-hidden
              showTooltip
              style={{
                display: 'inline-flex',
                position: 'absolute',
                left: '10px',
                top: '8px',
              }}
            />
          }
          placement="left"
          onClick={props.onUrlClick}
        >
          {listingLive ? 'Live Listing' : 'Not Live'}
        </LiveNotLiveButton>
      </NavButtonsWrapper>
    </ListingSectionTitleWrapper>
  );
}
